/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import type { JSX } from 'react'
import type { Mesh, MeshStandardMaterial } from 'three'
import type { GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      mesh485226736: Mesh
      mesh485226736_1: Mesh
      mesh485226736_2: Mesh
      mesh485226736_3: Mesh
      group256948792: Mesh
    }
    materials: {
      mat15: MeshStandardMaterial
      mat16: MeshStandardMaterial
      mat23: MeshStandardMaterial
      mat17: MeshStandardMaterial
      mat25: MeshStandardMaterial
    }
  }

export function Macbook(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('/models/macbook.glb') as GLTFResult
  return (
    <group {...props} dispose={null}>
      <group position-y={0.16}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.group256948792.geometry}
          material={materials.mat25}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.mesh485226736.geometry}
          material={materials.mat15}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.mesh485226736_1.geometry}
          material={materials.mat16}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.mesh485226736_2.geometry}
          material={materials.mat23}
        />
        <mesh castShadow geometry={nodes.mesh485226736_3.geometry} material={materials.mat17} />
      </group>
    </group>
  )
}

useGLTF.preload('/models/macbook.glb')
